export enum WindowMenuActionTypes {
	TOGGLE_IS_OPEN = "SET_IS_OPEN",
	SUBSCRIBE_MENU = "SUBSCRIBE_MENU",
	UNSUBSCRIBE_MENU = "UNSUBSCRIBE_MENU",
	TOGGLE_MENU_ITEM_IS_OPEN = "SET_MENU_ITEM_IS_OPEN",
	UPDATE_DATA = "UPDATE_DATA",
	HAS_NEW_CONTENT_TOGGLE = "HAS_NEW_CONTENT_TOGGLE",
}